/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 10:42:11
 * @LastEditTime: 2019-10-10 14:27:56
 * @LastEditors: Please set LastEditors
 */
export default [{
        path: '/Bmap',
        name: 'Bmap',
        component: resolve => require(['@/common/Bmap/Bmap.vue'], resolve),

    }, {
        path: '/',
        name: 'root',
        component: resolve => require(['@/views/logistics/root.vue'], resolve),
        redirect: 'survey',
        children: [{
                path: '/survey',
                name: 'survey',
                component: resolve => require(['@/views/logistics/survey.vue'], resolve)
            },
            {
                path: '/customer',
                name: 'customer',
                component: resolve => require(['@/views/customer/customer.vue'], resolve),
                redirect: 'next_leve',
                children: [{
                        path: '/next_leve',
                        name: 'next_leve',
                        component: resolve => require(['@/views/customer/next_leve.vue'], resolve)
                    },
                    {
                        path: '/storeManage',
                        name: 'storeManage',
                        component: resolve => require(['@/views/customer/storeManage.vue'], resolve)
                    },
                    {
                        path: '/lowerStoreManage',
                        name: 'lowerStoreManage',
                        component: resolve => require(['@/views/customer/lowerStoreManage.vue'], resolve)
                    },
                    //下级经销商门店核销报销数据
                    {
                        path: '/lowerStoreVerifyAndExpense',
                        name: 'lowerStoreVerifyAndExpense',
                        component: resolve => require(['@/views/customer/lowerStoreVerifyAndExpense.vue'], resolve)
                    },
                    {
                        path: '/lowerStoreDetail',
                        name: 'lowerStoreDetail',
                        component: resolve => require(['@/views/customer/lowerStoreDetail.vue'], resolve)
                    },
                    {
                        path: '/addStore',
                        name: 'addStore',
                        component: resolve => require(['@/views/customer/addStore.vue'], resolve)
                    }, {
                        // storeDetail  门店详情
                        path: '/storeDetail',
                        name: 'storeDetail',
                        component: resolve => require(['@/views/customer/storeDetail.vue'], resolve)
                    }, {
                        // addDealer
                        path: '/addDealer',
                        name: 'addDealer',
                        component: resolve => require(['@/views/customer/addDealer.vue'], resolve)
                    }, {
                        // dealerDetail
                        path: '/dealerDetail',
                        name: 'dealerDetail',
                        component: resolve => require(['@/views/customer/dealerDetail.vue'], resolve)
                    },
                    // 导购管理 guideManage
                    {
                        path: '/guideManage',
                        name: 'guideManage',
                        component: resolve => require(['@/views/customer/guide/guideManage.vue'], resolve),
                    },

                    // 添加导购
                    {
                        path: '/addGuide',
                        name: 'addGuide',
                        component: resolve => require(['@/views/customer/guide/addGuide.vue'], resolve)
                    },
                    // 审核
                    {
                        path: '/examine',
                        name: 'examine',
                        component: resolve => require(['@/views/customer/guide/examine.vue'], resolve)
                    },
                    // 超级导购
                    {
                        path: '/guide',
                        name: 'guide',
                        component: resolve => require(['@/views/guide/index.vue'], resolve)
                    },
                    // 财务管理
                    {
                        path: '/finance',
                        name: 'finance',
                        component: resolve => require(['@/views/finance/index.vue'], resolve)
                    },
                    /*******************二维码营销*******************/
                    {
                        path: '/scanMarket',
                        name: "scanMarket",
                        component: resolve => require(['@/views/scanMarket/index'], resolve)
                    },
                    /***扫码管理模板***/
                    {
                        path: '/scanManageTemplate',
                        name: 'scanManageTemplate',
                        component: resolve => require(['@/views/scanMarket/scanManageTemplate'], resolve)
                    },
                    // 概况
                    {
                        path: '/scanSurvey',
                        name: 'scanSurvey',
                        component: resolve => require(['@/views/scanMarket/scanSurvey'], resolve)
                    },
                    // 创建扫码模板
                    {
                        path: '/setScanTemplate',
                        name: 'setScanTemplate',
                        component: resolve => require(['@/views/scanMarket/setScanTemplate'], resolve)
                    },
                    /***创建活动第一步***/
                    {
                        path: '/setActivityOne',
                        name: 'setActivityOne',
                        component: resolve => require(['@/views/scanMarket/setActivityOne'], resolve)
                    },
                    // 创建活动第二步
                    {
                        path: '/setActivityTwo',
                        name: 'setActivityTwo',
                        component: resolve => require(['@/views/scanMarket/setActivityTwo'], resolve)
                    },
                    // 活动管理
                    {
                        path: '/activityManage',
                        name: 'activityManage',
                        component: resolve => require(['@/views/scanMarket/activityManage'], resolve)
                    },
                    // 扫码明细
                    {
                        path: '/scanInfo',
                        name: 'scanInfo',
                        component: resolve => require(['@/views/scanMarket/scanInfo'], resolve)
                    },
                    // 扫码记录
                    {
                        path: '/scanRecord',
                        name: 'scanRecord',
                        component: resolve => require(['@/views/scanMarket/scanRecord'], resolve)
                    },
                    // 数据统计
                    {
                        path: '/dataStatistics',
                        name: 'dataStatistics',
                        component: resolve => require(['@/views/scanMarket/dataStatistics'], resolve)
                    },
                    /****************财务管理****************/
                    // 数据统计
                    {
                        path: '/marketFunds',
                        name: 'marketFunds',
                        component: resolve => require(['@/views/financeManage/marketFunds'], resolve)
                    },
                ]
            },
            {
                path: '/goods',
                name: 'goods',
                component: resolve => require(['@/views/goods/goods.vue'], resolve),
                redirect: 'instockManage',
                children: [{
                        // 发货管理
                        path: '/deliverManage',
                        name: 'deliverManage',
                        component: resolve => require(['@/views/goods/deliverManage/deliverManage.vue'], resolve)
                    },
                    //修改发货
                    {
                        path: '/editDeliver',
                        name: 'editDeliver',

                        component: resolve => require(['@/views/goods/deliverManage/editDeliver.vue'], resolve)
                    },
                    //添加发货
                    {
                        path: '/addDeliver',
                        name: 'addDeliver',

                        component: resolve => require(['@/views/goods/deliverManage/addDeliver.vue'], resolve)
                    },

                    {
                        // 入库管理
                        path: '/instockManage',
                        name: 'instockManage',
                        component: resolve => require(['@/views/goods/instockManage/instockManage.vue'], resolve)
                    },
                    //添加入库
                    {
                        path: '/addInstock',
                        name: 'addInstock',

                        component: resolve => require(['@/views/goods/instockManage/addInstock.vue'], resolve)
                    },
                    //退货管理
                    {
                        path: '/refundManage',
                        name: 'refundManage',
                        component: resolve => require(['@/views/goods/refundManage/refundManage.vue'], resolve)
                    },

                    //追踪查询
                    {
                        path: '/traceManage',
                        name: 'traceManage',
                        component: resolve => require(['@/views/goods/traceManage/traceManage.vue'], resolve)
                    },
                    {
                        // 调拨单管理
                        path: '/requisitionManage',
                        name: 'requisitionManage',
                        component: resolve => require(['@/views/goods/requisitionManage/requisitionManage.vue'], resolve)
                    }, {
                        // 零售管理
                        path: '/retailManage',
                        name: 'retailManage',
                        component: resolve => require(['@/views/goods/retailManage/retailManage.vue'], resolve)

                    }

                ]
            },
            {
                path: '/base',
                name: 'base',
                component: resolve => require(['@/views/base/base.vue'], resolve),
                children: [{
                        path: '/basicSetting',
                        name: 'basicSetting',
                        component: resolve => require(['@/views/base/basicSetting/basicSetting.vue'], resolve)
                    },
                    //仓库设置
                    {
                        path: '/instockSetting',
                        name: 'instockSetting',
                        component: resolve => require(['@/views/base/stockSetting/instockSetting.vue'], resolve)
                    },
                    //添加/编辑仓库
                    {
                        path: '/addStock',
                        name: 'addStock',
                        component: resolve => require(['@/views/base/stockSetting/addStock.vue'], resolve)
                    }
                ]
            }, {
                // 订单管理
                path: '/order',
                name: 'order',
                component: resolve => require(['@/views/order/order.vue'], resolve),
                children: [
                    //商品上架管理
                    {
                        path: '/goodsOnput',
                        name: 'goodsOnput',
                        component: resolve => require(['@/views/order/goodsOnput/goodsOnput.vue'], resolve)
                    },
                    // 商品上架
                    {

                        path: '/generalOnput',
                        name: 'generalOnput',
                        component: resolve => require(['@/views/order/goodsOnput/generalOnput.vue'], resolve)
                    },
                    // 指定商品上架
                    {
                        // specifyOnput
                        path: '/specifyOnput',
                        name: 'specifyOnput',
                        component: resolve => require(['@/views/order/goodsOnput/specifyOnput.vue'], resolve)
                    },
                    // 我的订单
                    {
                        path: '/myorder',
                        name: 'myorder',
                        component: resolve => require(['@/views/order/myorder/myorder.vue'], resolve)

                    },
                    // 我的详情订单
                    {
                        path: '/myorderDetail',
                        name: 'myorderDetail',
                        component: resolve => require(['@/views/order/myorder/myorderDetail.vue'], resolve)

                    },
                    // 下级订单
                    {
                        path: '/next_order',
                        name: 'next_order',
                        component: resolve => require(['@/views/order/next_order/next_order.vue'], resolve)

                    },
                    // 下级订单详情
                    {
                        path: '/next_detail',
                        name: 'next_detail',
                        component: resolve => require(['@/views/order/next_order/next_detail.vue'], resolve)

                    },
                    // 下级订单审核
                    {
                        path: '/next_review',
                        name: 'next_review',
                        component: resolve => require(['@/views/order/next_order/next_review.vue'], resolve)

                    },
                    // 门店订单
                    {
                        path: '/store_order',
                        name: 'store_order',
                        component: resolve => require(['@/views/order/store_order/store_order.vue'], resolve)
                    },
                    // 门店订单详情
                    {
                        path: '/store_detail',
                        name: 'store_detail',
                        component: resolve => require(['@/views/order/store_order/store_detail.vue'], resolve)
                    },
                    // 门店订单审核
                    {
                        path: '/store_review',
                        name: 'store_review',
                        component: resolve => require(['@/views/order/store_order/store_review.vue'], resolve)
                    },
                    // 我的返利
                    {
                        path: '/rebate',
                        name: 'rebate',
                        component: resolve => require(['@/views/order/rebate/rebate.vue'], resolve)
                    }
                ]
            },
            {
                // 信息管理
                path: '/info',
                name: 'info',
                component: resolve => require(['@/views/info/info.vue'], resolve),
                children: [{
                        // 文件库
                        path: '/library',
                        name: 'library',
                        component: resolve => require(['@/views/info/library/library.vue'], resolve),
                    },
                    {
                        // 添加文件 addFile
                        path: '/addFile',
                        name: 'addFile',
                        component: resolve => require(['@/views/info/library/addFile.vue'], resolve),

                    },
                    {
                        // 公告列表
                        path: '/announcement',
                        name: 'announcement',
                        component: resolve => require(['@/views/info/announcement/announcement.vue'], resolve),
                    },
                    // 发布公告
                    {
                        // releaseAnnouncement
                        path: '/releaseAnnouncement',
                        name: 'releaseAnnouncement',
                        component: resolve => require(['@/views/info/announcement/releaseAnnouncement.vue'], resolve),
                    },
                    {
                        // announcementCate 添加分类
                        path: '/announcementCate',
                        name: 'announcementCate',
                        component: resolve => require(['@/views/info/announcement/announcementCate.vue'], resolve),
                    }
                ]
            },
            {
                // 统计 报表
                path: '/statistics',
                name: 'statistics',
                component: resolve => require(['@/views/statistics/statistics.vue'], resolve),
                children: [{
                        // 产品周转率
                        path: '/turnover',
                        name: 'turnover',
                        component: resolve => require(['@/views/statistics/turnover/turnover.vue'], resolve),

                    },
                    {
                        // 门店订单排行
                        path: '/orderRaking',
                        name: 'orderRaking',
                        component: resolve => require(['@/views/statistics/orderRaking/orderRaking.vue'], resolve),

                    },
                    {
                        // 库存统计
                        path: '/inventoryStatistics',
                        name: 'inventoryStatistics',
                        component: resolve => require(['@/views/statistics/inventoryStatistics/inventoryStatistics.vue'], resolve),

                    },
                    {
                        // 生意情况
                        path: '/business',
                        name: 'business',
                        component: resolve => require(['@/views/statistics/business/business.vue'], resolve),

                    }
                ]
            },
            {
                // 系统管理
                path: '/system',
                name: 'system',
                component: resolve => require(['@/views/system/system.vue'], resolve),
                children: [{
                        // 员工管理
                        path: '/staffManagement',
                        name: 'staffManagement',
                        component: resolve => require(['@/views/system/staffManagement/staffManagement.vue'], resolve)

                    },
                    {
                        // 添加员工
                        path: '/addStaff',
                        name: 'addStaff',
                        component: resolve => require(['@/views/system/staffManagement/addStaff.vue'], resolve)

                    },
                    {
                        // 日志
                        path: '/log',
                        name: 'log',
                        component: resolve => require(['@/views/system/log/log.vue'], resolve)
                    }
                ]
            },
            {
                path: '/message',
                name: 'message',
                component: resolve => require(['@/views/logistics/message.vue'], resolve),
            },
            {
                path: '/expense',
                name: 'expense',
                component: resolve => require(['@/views/expense/expense.vue'], resolve),
                children: [
                    //下级报销管理
                    {
                        path: '/lowerExpenseManage',
                        name: 'lowerExpenseManage',
                        component: resolve => require(['@/views/expense/lowerExpenseManage.vue'], resolve)
                    },
                    //我要报销
                    {
                        path: '/dealerExpenseListManage',
                        name: 'dealerExpenseListManage',
                        component: resolve => require(['@/views/expense/dealerExpenseListManage.vue'], resolve)
                    },
                    //我的报销统计
                    {
                        path: '/dealerExpenseStatistic',
                        name: 'dealerExpenseStatistic',
                        component: resolve => require(['@/views/expense/dealerExpenseStatistic.vue'], resolve)
                    },

                ]
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            requireAuth: '1'
        },
        component: resolve => require(['@/views/logistics/login.vue'], resolve),
    }
]